import * as ActionTypes from '../actions/ActionTypes';
import CustomerPortalSettingsRecord from 'knowledge-content-ui/records/CustomerPortalSettingsRecord';
const INITIAL_STATE = new CustomerPortalSettingsRecord();
export default function customerPortalSettings(state = INITIAL_STATE, {
  payload,
  type
}) {
  switch (type) {
    case ActionTypes.FETCH_CUSTOMER_PORTAL_SETTINGS_SUCCESS:
      if (!payload) return state;
      return state.merge({
        enabled: payload.enabled
      });
    default:
      return state;
  }
}